import { Button } from "primereact/button";
import React from "react";
import { useTranslation } from "@i18n/hooks";
import { type TimestampWithImageTemplateProps } from "./timestamp-with-image-template.interface";

export const TimestampWithImageTemplate = ({
	timestampWithImage,
	edit,
	remove,
}: TimestampWithImageTemplateProps) => {
	const { t } = useTranslation("common");
	return (
		<div className="flex align-items-center justify-content-between">
			<div>
				{timestampWithImage.start}
				{" - "}
				{timestampWithImage.end}
				{" - "}
				{timestampWithImage.imageFileId
					? t("educationalOffer.withImage")
					: t("educationalOffer.withoutImage")}
			</div>
			<div>
				<Button type="button" className="ml-2" icon="pi pi-pencil" onClick={edit} />
				<Button type="button" className="ml-2" icon="pi pi-trash" onClick={remove} />
			</div>
		</div>
	);
};
